import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class BrandListDataService extends DataService<typeof Model.General.Logic.ViewModels.BrandSummary, Model.General.Logic.ViewModels.BrandSummary, BrandSummary> {
    protected map(entity: Model.General.Logic.ViewModels.BrandSummary): BrandSummary {
        return new BrandSummaryModel(entity);
    }

    static make(context?: any): BrandListDataService {
        return new BrandListDataService(context, ctx => ctx.BrandSummaries);
    }
}

export class BrandSummaryModel extends EntityModel<Model.General.Logic.ViewModels.BrandSummary, BrandSummary> implements BrandSummary {

    @property<BrandSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<BrandSummaryModel>(o => o.entity.name, (o, value) => o.entity.name = value)
    public name: string;

    @property<BrandSummaryModel>(o => o.entity.description, (o, value) => o.entity.description = value)
	public description: string;

	@property<BrandSummaryModel>(o => o.entity.prefix, (o, value) => o.entity.prefix = value)
	prefix: string
}




// WEBPACK FOOTER //
// ./src/app/general/brands/list/brand-list.data.ts